export enum CambioJefeHogarRazon {
  Fallecimiento = "Fallecimiento",
  Discapacidad = "Discapacidad",
  MutuoAcuerdo = "Mutuo acuerdo",
  AusenciaDefinifiva = "Ausencia definitiva o abandono"
}
